// removed by extract-text-webpack-plugin
module.exports = {"dataChangedTooltip":"tooltip__dataChangedTooltip-_VrR7 blocks__tooltip-20lA1 blocks__error-2TffC blocks__isShown--23z3"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/tooltip/tooltip.css
// module id = 828
// module chunks = 0